import { FC } from 'react';
import { world } from '../../languages';
import cn from '../../utils/classnames';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import useMarketingBar from './hooks/use-marketing-bar';
import './marketing-bar.scss';

const MarketingBar: FC<{ schoolVersion?: string }> = () => {
    const { showBar, closeSpecialMessage, handleBannerClick, marketingBarData } = useMarketingBar();

    if (!showBar || !marketingBarData) {
        return null;
    }

    const { MessageComponent } = marketingBarData;

    return (
        <div className={cn('marketing-bar d-lg-block', world, {})}>
            <div onClick={handleBannerClick}>
                <MessageComponent />
            </div>
            <span className='close-special' onClick={closeSpecialMessage}>
                <FontAwesomeIcon height={14} name='close' width={12} />
            </span>
        </div>
    );
};

export default MarketingBar;
